export enum ResultDirectionEnum {
	BIDIRECTIONAL = 'bidirectional',
	INCOMING = 'incoming',
	OUTGOING = 'outgoing',
}
